/**
 * Where to send a user back to after onboarding hands them to another site.
 * Connector OAuth callbacks land on fixed pages (/integrations,
 * /sequencing/settings) and Stripe Checkout returns to `/?trial=...` or
 * `/plans?status=cancelled`; a marker set just before leaving tells the app
 * to bring them back to the onboarding step (or the first chat) instead.
 *
 * sessionStorage: the marker belongs to this tab's trip and dies with it.
 */

const KEY = 'cl_onboarding_return';

/** `connect` and `trial` are onboarding steps; `chat` is Clu's first chat. */
export type OnboardingReturn = 'connect' | 'trial' | 'chat';

export function setOnboardingReturn(target: OnboardingReturn): void {
  try {
    sessionStorage.setItem(KEY, target);
  } catch {
    // Storage off: the user lands where the provider sends them.
  }
}

export function peekOnboardingReturn(): OnboardingReturn | null {
  try {
    const value = sessionStorage.getItem(KEY);
    return value === 'connect' || value === 'trial' || value === 'chat'
      ? value
      : null;
  } catch {
    return null;
  }
}

export function clearOnboardingReturn(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
